<template>
    <div>
        <a-popover trigger="click">
            <template #content>
                <div ref="domNode" class="sc-emoji-picker" tabIndex="0" @blur="onBlur">
                    <div class="sc-emoji-picker--content">
                        <div v-for="category in emojiData" :key="category.name" class="sc-emoji-picker--category">
                            <div class="sc-emoji-picker--category-title">
                                {{ category.name }}
                            </div>
                            <span
                                v-for="emoji in category.emojis"
                                :key="emoji"
                                class="sc-emoji-picker--emoji"
                                @click="emojiClicked(emoji)"
                            >
                                {{ emoji }}
                            </span>
                        </div>
                    </div>
                </div>
            </template>
            <div v-if="isSlot()" @click="emojiClickHandler">
                <slot name="button" />
            </div>
            <div v-else style="z-index: 9999" @click="emojiClickHandler">
                <md-icon> sentiment_very_satisfied</md-icon>
            </div>
        </a-popover>
    </div>
</template>

<script>
import EmojiConvertor from "emoji-js";
import emojiData from "./popup-chat/emojiData.js";
import _ from "lodash";

export default {
    name: "EmojiButton",
    data() {
        return {
            emojiData,
            emojiConvertor: new EmojiConvertor(),
            showEmojiTable: false,
        };
    },
    props: {
        onEmojiPicked: {
            type: Function,
            required: true,
        },
    },
    methods: {
        isSlot() {
            return this.$slots["button"];
        },
        emojiClickHandler() {
            this.showEmojiTable = true;
        },
        emojiClicked(emoji) {
            this.onEmojiPicked(emoji);
            this.$refs.domNode.blur();
        },
        onBlur() {},
    },
    mounted() {
        const elem = _.get(this.$refs, "domNode");
        if (elem) {
            elem.style.opacity = 0;
            window.requestAnimationFrame(() => {
                elem.style.transition = "opacity 350ms";
                elem.style.opacity = 1;
            });
            this.$refs.domNode.focus();
            this.emojiConvertor.init_env();
        }
    },
};
</script>

<style scoped>
.sc-emoji-picker--content {
    padding: 5px;
    overflow: auto;
    width: 200px;
    max-height: 195px;
    box-sizing: border-box;
}

.sc-emoji-picker--category {
    flex-direction: row;
    flex-wrap: wrap;
}

.sc-emoji-picker--category-title {
    min-width: 100%;
    color: #8f7b7b;
    font-weight: 200;
    font-size: 13px;
    margin: 5px;
    letter-spacing: 1px;
}

.sc-emoji-picker--emoji {
    margin: 5px;
    width: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    vertical-align: middle;
    font-size: 28px;
    transition: transform 60ms ease-out, -webkit-transform 60ms ease-out;
}

.sc-emoji-picker--emoji:hover {
    transform: scale(1.4);
}
</style>
